import { useStore } from '@nanostores/preact'
import classNames from 'utils/preact/class-names'
import { useTranslation } from './Translation'
import { profile } from '../services/store'
import { ProductDuration } from '../services/support'
import css from '../style.module.scss'
import checkIcon from '../static/icon-check--white.svg'
import { useUserData } from '../hooks/useUserData'

export function SubscriptionButtons() {
  const t = useTranslation()
  const user = useStore(profile)
  const { currency, products } = useUserData()

  return (
    <div className={css['subscription-buttons']}>
      {['annually', 'monthly'].map((type: ProductDuration) => {
        const price = products[type].prices[currency.acronym]
        return (
          <label
            key={type}
            className={classNames({
              [css['radio-label']]: true,
              [css['is-active']]: user.subscription === type
            })}
            htmlFor={`subscription-${type}`}
          >
            <p className={css['subscription-name']}>{t(`support_${type}`)}</p>
            <p className={css['subscription-price']}>
              {currency.prefix}&thinsp;{price.unit_amount / 100}
            </p>
            <p className={css['subscription-comment']}>
              {t(`offers_comment_${type}`, {
                price: currency.prefix + (price.unit_amount / 100 / 12).toFixed(2)
              })}
            </p>
            <img src={checkIcon} alt="checkmark" width={12} className={css['check-icon']} />
            <input
              type="radio"
              name="subscription"
              value={type}
              className={css['radio-input']}
              id={`subscription-${type}`}
              onChange={() => profile.setKey('subscription', type)}
            />
          </label>
        )
      })}
    </div>
  )
}
